import { Link } from "react-router-dom";
import { hotSearch } from "@/mocks/categories";
import { events } from "@/mocks/events";

export default function HotBoard() {
  const brief = events.slice(0, 3);

  return (
    <section id="hot" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
          <div>
            <p className="eyebrow">
              <i className="ri-fire-line" aria-hidden="true"></i>
              今日热榜
            </p>
            <h2 className="section-title mt-4">此刻被讨论最多的事</h2>
          </div>
          <p className="max-w-md font-body text-sm leading-relaxed text-foreground-600">
            榜单按公开讨论量排布，只反映「被讨论的热度」，不代表事件的是非判断。点进任意一条都能看到完整时间线。
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-6 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <ol className="card-surface divide-y divide-background-100 overflow-hidden">
              {hotSearch.map((item) => (
                <li key={item.title}>
                  <Link
                    to="/topics"
                    className="group flex items-center gap-4 px-4 py-4 transition-colors duration-200 hover:bg-background-100 md:px-6"
                  >
                    <span
                      className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-md font-heading text-sm font-bold ${
                        item.rank <= 3
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-200 text-foreground-600"
                      }`}
                    >
                      {item.rank}
                    </span>
                    <span className="flex-1 font-body text-sm text-foreground-900 group-hover:text-primary-600 md:text-base">
                      {item.title}
                    </span>
                    {item.tag && (
                      <span className="hidden shrink-0 rounded-full bg-accent-100 px-2 py-0.5 font-label text-[11px] text-accent-900 sm:inline-block">
                        {item.tag}
                      </span>
                    )}
                    <span className="shrink-0 font-label text-xs text-foreground-500">{item.heat}</span>
                  </Link>
                </li>
              ))}
            </ol>
          </div>

          <aside className="rounded-lg border border-secondary-200 bg-secondary-50 p-5 md:p-6">
            <h3 className="flex items-center gap-2 font-heading text-lg font-bold text-secondary-950">
              <i className="ri-alarm-warning-line text-secondary-600" aria-hidden="true"></i>
              热点速览
            </h3>
            <p className="mt-2 font-body text-sm leading-relaxed text-secondary-900/80">
              刚更新的三份档案，适合先看概述再决定要不要细读。
            </p>
            <ul className="mt-5 flex flex-col gap-4">
              {brief.map((item) => (
                <li key={item.id} className="border-t border-secondary-200 pt-4 first:border-0 first:pt-0">
                  <Link to={`/topic/${item.id}`} className="group block">
                    <span className="font-label text-[11px] text-secondary-700">
                      {item.categoryName} · {item.date}
                    </span>
                    <h4 className="mt-1.5 font-heading text-sm font-bold leading-snug text-secondary-950 transition-colors group-hover:text-primary-600">
                      {item.title}
                    </h4>
                    <p className="mt-1.5 line-clamp-2 font-body text-xs leading-relaxed text-secondary-900/70">
                      {item.summary}
                    </p>
                  </Link>
                </li>
              ))}
            </ul>
            <Link to="/topics" className="btn-secondary mt-6 w-full border-secondary-300 bg-background-50">
              查看全部档案
            </Link>
          </aside>
        </div>
      </div>
    </section>
  );
}